import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { Assign } from 'utility-types';
import { BannerOptions } from '../banner/banner.component';
import { CheckboxGroupOptions } from '../checkbox-group/checkbox-group.component';
import { AttachComponentsService } from '../form-core/attach-components/attach-components.service';
import { DestroyService } from '../form-core/destroy/destroy.service';
import { ParserService } from '../form-core/parser/parser.service';
import { InfoOptions } from '../info/info.component';
import { ModalOpenerOptions } from '../modal-opener/modal-opener.component';
import { ReviewOptions } from '../review/review.component';
import { SelectOptions } from '../select/select.component';
import { State } from '../store';
import { selectRouteParam } from '../store/router-reducers';
import { TextInputOptions } from '../text-input/text-input.component';
import { ScrollService } from './scroll.service';

@Component({
  selector: 'div[data-component-type=step]',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ScrollService]
})
export class StepComponent implements OnInit, OnDestroy {

  @Input() fieldsets$: Observable<FieldsetOptions[]> = this.store.pipe(
    select(selectRouteParam('id')),
    switchMap(id => this.parser.get(id as string))
  )

  constructor(private attachComponents: AttachComponentsService, private store: Store<State>, private parser: ParserService, private des: DestroyService) { }
  
  ngOnInit(): void {
    this.attachComponents.attach()
  }

  ngOnDestroy(): void {
    this.attachComponents.destroy()
    this.des.destroy()
  }

  trackByFn(index: number, item: FieldsetOptions) {
    return item.id
  }

}

export interface FieldsetOptions {
  legend?: string,
  classes?: string,
  components: (Assign<Omit<TextInputOptions | SelectOptions | ReviewOptions, 'position'>, {inline: boolean}> | BannerOptions | InfoOptions | CheckboxGroupOptions)[],
  presence: boolean,
  id: string,
  type: 'fieldset',
  opener?: ModalOpenerOptions
}